import {
  FaFacebook,
  FaInstagram,
  FaMusic,
  FaSoundcloud,
  FaSpotify,
  FaTiktok,
  FaTwitter,
  FaYoutube,
  FaGlobe,
  FaApple,
} from "react-icons/fa";
import {
  KYDAdminFeed,
  KYDSocialPlatforms,
} from "@common/interfaces/KYDOrganization";
import {
  Button,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Switch,
} from "@chakra-ui/react";

export const getIconComponent = (
  platform: KYDSocialPlatforms | "facebook"
): React.ElementType => {
  switch (platform) {
    case "twitter":
      return FaTwitter;
    case "facebook":
      return FaFacebook;
    case "spotify":
      return FaSpotify;
    case "instagram":
      return FaInstagram;
    case "applemusic":
      return FaApple;
    case "youtube":
      return FaYoutube;
    case "soundcloud":
      return FaSoundcloud;
    case "tiktok":
      return FaTiktok;
    case "website":
      return FaGlobe;
    default:
      return FaGlobe;
  }
};

export const getIconForSocial = (platform: KYDSocialPlatforms | "facebook") => {
  let icon;
  let placeholder;
  switch (platform) {
    case "twitter":
      placeholder = "Twitter Link";
      break;
    case "facebook":
      icon = <FaFacebook />;
      placeholder = "Facebook Link";
      break;
    case "spotify":
      placeholder = "Spotify Link";
      break;
    case "instagram":
      placeholder = "Instagram Link";
      break;
    case "applemusic":
      placeholder = "Apple Music Link";
      break;
    case "youtube":
      placeholder = "YouTube Link";
      break;
    case "soundcloud":
      placeholder = "Soundcloud Link";
      break;
    case "tiktok":
      placeholder = "Soundcloud Link";
      break;
    case "website":
      placeholder = "Website Link";
      break;
    default:
      icon = platform;
      placeholder = `${platform} link`;
      break;
  }

  const IconComponent = getIconComponent(platform);
  return {
    icon: IconComponent,
    placeholder,
  };
};

const SocialInput = ({
  type,
  updateDirtyText,
  dirtyText,
  onUpdateSocial,
  loading,
  feed,
}: {
  type: KYDSocialPlatforms;
  updateDirtyText: (obj: Record<string, any>) => void;
  dirtyText: Record<string, any>;
  onUpdateSocial: (type: string, link?: string, enabled?: boolean) => void;
  loading: Record<KYDSocialPlatforms | string, boolean>;
  feed: KYDAdminFeed | null;
}) => {
  const { icon: Icon, placeholder } = getIconForSocial(type);

  return (
    <InputGroup size={"md"} alignItems={"center"}>
      <InputLeftElement children={<Icon />} />
      <Input
        maxW="500px"
        placeholder={placeholder}
        onChange={(e) => updateDirtyText({ [`${type}.link`]: e.target.value })}
        value={
          dirtyText[`${type}.link`] || feed?.organization.socials[type]?.link
        }
        pr="4.5rem"
      />
      {`${type}.link` in dirtyText && dirtyText[`${type}.link`] ? (
        <InputRightElement mr={"6rem"} width="4.5rem">
          <Button
            isDisabled={loading[`social.${type}`]}
            isLoading={loading[`social.${type}`]}
            onClick={() => onUpdateSocial(type, dirtyText[`${type}.link`])}
            h="1.75rem"
            size={"sm"}
          >
            Save
          </Button>
        </InputRightElement>
      ) : null}

      {feed?.organization.socials[type]?.link ? (
        <Switch
          colorScheme="green"
          defaultChecked={feed?.organization.socials[type]?.enabled}
          isDisabled={loading[`social.${type}`]}
          onChange={(e) => onUpdateSocial(type, undefined, e.target.checked)}
          ml={2}
        />
      ) : null}
    </InputGroup>
  );
};

export default SocialInput;
